export type ConnectionStatus = 'connecting' | 'connected' | 'reconnecting' | 'polling' | 'disconnected';

interface ConnectionStatusIndicatorProps {
  status: ConnectionStatus;
}

const STATUS_CONFIG: Record<ConnectionStatus, { label: string; dotColor: string }> = {
  connected: {
    label: 'Verbunden',
    dotColor: 'bg-green-500',
  },
  connecting: {
    label: 'Verbindung wird hergestellt...',
    dotColor: 'bg-yellow-500',
  },
  reconnecting: {
    label: 'Verbindung wird wiederhergestellt...',
    dotColor: 'bg-yellow-500',
  },
  polling: {
    label: 'Polling (WS nicht verfügbar)',
    dotColor: 'bg-orange-500',
  },
  disconnected: {
    label: 'Getrennt',
    dotColor: 'bg-red-500',
  },
};

export default function ConnectionStatusIndicator({ status }: ConnectionStatusIndicatorProps) {
  const config = STATUS_CONFIG[status];

  return (
    <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
      <span
        className={`w-2.5 h-2.5 rounded-full ${config.dotColor} ${
          (status === 'reconnecting' || status === 'connecting') ? 'animate-pulse' : ''
        }`}
      />
      <span>{config.label}</span>
    </div>
  );
}
